import { StateCreator } from "zustand";

import { FiltersActions, FiltersSlice, RollForwardWizardStore } from "../roll_forward_wizard_store_types";

export const createFiltersSlice: StateCreator<
  RollForwardWizardStore,
  [["zustand/immer", never]],
  [],
  FiltersSlice
> = () => ({
  filters: {}
});

export const createFiltersActions = (): FiltersActions => ({});
